import {
  BackgroundColors,
  NegativeColors,
  PositiveColors,
  TextColors,
} from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { canHover, canTouch } from '@picsart/design-system/foundation/styleHelpers';
import { mediaQuery } from '@picsart/rc/helpers';
import { Timings } from '@picsart/design-system/foundation/timings';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  () => ({
    root: {
      position: 'relative',
      width: '100%',
      height: 287,

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        height: 220,
      },
    },
    centered: {
      padding: [Spacings.s0, Spacings.s32],
      margin: [Spacings.s0, 'auto'],
      maxWidth: '100%',
      width: 1056,

      [mediaQuery(1023)]: {
        width: 768,
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        width: '100%',
      },
    },
    slide: {
      position: 'absolute',
      left: Spacings.s0,
      top: Spacings.s0,
      height: '100%',
      width: '100%',
      backgroundPosition: '50% 50%',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      opacity: 0,
      transition: `opacity 0.46s ease`,

      '&.active': {
        opacity: 1,
        zIndex: 1,
      },
    },
    content: {
      position: 'absolute',
      left: Spacings.s0,
      top: Spacings.s0,
      justifyContent: 'center',
      flexDirection: 'column',
      alignItems: 'center',
      flexWrap: 'wrap',
      display: 'flex',
      width: '100%',
      height: '100%',
      zIndex: 2,
    },
    title: {
      marginBottom: Spacings.s44,
      width: '100%',
      color: NegativeColors.text.default,
      fontSize: FontSizes.s36,
      fontWeight: FontWeights.normal,
      lineHeight: LineHeights.l48,
      textAlign: 'center',

      '&:last-child': {
        marginBottom: Spacings.s0,
      },

      '& > span': {
        fontWeight: FontWeights.bold,
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        fontSize: FontSizes.s24,
      },
    },
    button: {
      padding: [Spacings.s12, Spacings.s32],
      color: TextColors.base,
      border: 'none',
      lineHeight: LineHeights.l16,
      fontWeight: FontWeights.semibold,
      fontSize: FontSizes.s14,
      backgroundColor: PositiveColors.base.default,
      borderRadius: 100,
      cursor: 'pointer',
      transition: `background-color ${Timings.default} ease`,

      [canHover]: {
        '&:hover': {
          backgroundColor: BackgroundColors.tint3,
        },
      },
      [canTouch]: {
        '&:active': {
          backgroundColor: BackgroundColors.tint3,
        },
      },
    },
  }),
  {
    name: 'brands-carousel',
  },
);

export default useStyles;
